let loadPromise: Promise<void> | null = null;
const MATHPIX_KEY = 'mathpix-it-markdown-resource';

/**
 * @private
 * @returns
 */
const loadPromiseFactory = () => {
  const p: Promise<void> = new Promise((resolve, reject) => {
    const mathpixDom = document.getElementById(MATHPIX_KEY);
    mathpixDom && mathpixDom.parentNode?.removeChild(mathpixDom);
    const scriptEl = document.createElement('script');
    scriptEl.src = 'https://mathresource.studyquicks.com/static/bundle_v1.2.25.js';
    scriptEl.defer = true;
    scriptEl.id = MATHPIX_KEY;

    document.body.appendChild(scriptEl);
    scriptEl.onload = () => resolve();
    scriptEl.onerror = (err: any) => reject(err);
  });

  p.catch((err: Error) => {
    loadPromise = null;
    return Promise.reject(err);
  });

  return p;
};

export const loadMMD = () => {
  if (loadPromise === null) {
    loadPromise = loadPromiseFactory();
  }
  return loadPromise;
};

export const renderLatex = (md: string) => {
  return (
    (window as any)?.mathpix?.render?.(md, {
      delimiters: [
        { left: '$$', right: '$$', display: true },
        { left: '$', right: '$', display: false },
        { left: '\\(', right: '\\)', display: false },
        { left: '\\[', right: '\\]', display: true },
      ],
      disableRules: ['emoji'],
      htmlTags: true,
      parserErrors: 'show_input',
    }) || md
  );
};
